// import node module libraries
import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
} from "react";
import { Link } from "react-router-dom";

//import Select from 'react-select';

import LinkIcon from "react-feather/dist/icons/link";
import ImageIcon from "react-feather/dist/icons/image";
import { Trash, XCircle, Copy, Video } from "react-feather";
import {
  Col,
  Row,
  Breadcrumb,
  Card,
  Button,
  Form,
  InputGroup,
  FormControl,
  ListGroup,
  Image,
  Div,
  Badge,
  Toast,
} from "react-bootstrap";

// import custom components
import { FlatPickr } from "components/elements/flat-pickr/FlatPickr";
import { FormSelect } from "components/elements/form-select/FormSelect";
import { DropFiles } from "components/elements/dropfiles/DropFiles";
import DotBadge from "components/elements/bootstrap/DotBadge";
//import ReactQuillEditor from 'components/elements/editor/ReactQuillEditor';
import ReactQuillEditor from "react-quill";

// import media files
import Avatar1 from "assets/images/avatar/avatar-1.jpg";

import Url from "../../Url";

const AddNewPost = (props) => {
  const url1 = Url();
  const url = url1["url"];
  const s3 = url1["s3"];
  const [blog, setBlog] = useState([]);
  const id = props.match.params.id;
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [authorOptions, setAuthorOptions] = useState([]);
  const [image, setImage] = useState();
  const [show, setShow] = useState(false);
  const [fetchAgain, setFetchAgain] = useState(false)

  const activeIndList = [
    { value: 0, label: "Draft" },
    { value: 1, label: "Under Review" },
    { value: 2, label: "Published" },
    { value: 3, label: "Deleted" },
  ];
  const [formData, setFormData] = useState({
    content_header: null,
    content_type_id: 1,
    preview_text: null,
    category_id: "",
    upvotes_count: null,
    downvotes_count: null,
    image_1000_540_scroller: null,
    image_1000_540_scroller_alt: null,
    image_1000_540_blog_preview: null,
    image_1000_540_blog_preview_alt: null,
    content_order_number: null,
    active_ind: "",
    author_id: "",
    last_user_id: null,
    element_description: null,
    seo_title:null,
    meta_description:null,
    meta_keywords:null,
    created_at: null,
  });

  const [quillValue, setQuillValue] = useState("");
  /*
	const constructor = (props) =>
	{
		//super(props);

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.state = {content_header :null,content_type_id :1,preview_text :null,category_id :'',upvotes_count :null,downvotes_count :null,image_1000_540_scroller :null,image_1000_540_scroller_alt :null,image_1000_540_blog_preview :null,image_1000_540_blog_preview_alt :null,content_order_number :null,active_ind :'',author_id :'',last_user_id :null,element_description :null,created_at:null};
	}
	*/

  // Form submitting logic, prevent default page refresh
  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(formData);

    const api = url + "updateContent";
    //console.log(postData);
    //return ;
    fetch(api, {
      method: "POST",
      body: JSON.stringify(formData),
      headers: { "Content-Type": "application/json" },
    })
      .then((apidata1) => {
        return apidata1.json();
      })
      .then((actualdata) => {
        window.scrollTo(0, 0);
        setShow(true);
        setFetchAgain(true);
        /*
			if (actualdata["message"] === "applicant_education updated") {
				setIsSent(true);
				setEduaddmore(false);
				setShow(false);
				toast.success("Education status updated successfully....", {
				position: toast.POSITION.TOP_CENTER,
				autoClose: 2000,
				});
			}
			*/

        console.log(actualdata);
        if(actualdata.contentId){
          window.location.href = "/cms/blog-details/" + actualdata.contentId;
        }
      });
  };

  const handleChange = (event) => {
    //setFormData({...formData, [event.target.name]:event.target.value} );
    //setFormData( {[event.target.name]:event.target.value} );

    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    //this.setState({ [event.target.name]: event.target.value });
    console.log(formData);
  };

  const handleImageChange = async (event) => {
    const imgFile = event.target.files[0];
    const fd = new FormData();
    fd.append("pic", imgFile);

    fetch(url + "uploadBlogImage", {
      method: "POST",
      body: fd,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setFormData({ ...formData, image_1000_540_scroller: data["message"] });
      });
  };

  const handleEditorChange = (content) => {
    const { name, value } = { name: "element_description", value: content };
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    /*
		setFormData({ ...formData, element_description: content });
		console.log(content);
		*/
    console.log(formData);
  };

  useEffect(() => {
    console.log(formData);

    if (!id) {
      id = 0;
    }
    const api = url + "getContentDetails/" + id;

    fetch(api, {
      method: "GET",
    })
      .then((apidata) => {
        return apidata.json();
      })
      .then((actualdata) => {
        //console.log(actualdata);
        if (actualdata.contentData.length > 0) {
          setBlog(actualdata.contentData[0]);
          setFetchAgain(false);
        }
        setCategoryOptions(actualdata.cateogyList);
        setAuthorOptions(actualdata.authorList);
        //this.setState({data:actualdata.contentData[0]});

        setFormData({ ...actualdata.contentData[0] });
      });
  }, [fetchAgain]);

  return (
    <Fragment>
      <Row>
        <Col lg={12} md={12} sm={12}>
          <div className="border-bottom pb-4 mb-4 d-md-flex align-items-center justify-content-between">
            <div className="mb-3 mb-md-0">
              <h1 className="mb-1 h2 fw-bold">
                {id ? "Edit Blog" : "Add New Blog"}
              </h1>
              <Breadcrumb>
                <Breadcrumb.Item href="#">Dashboard</Breadcrumb.Item>
                <Breadcrumb.Item href="/cms/all-posts">Blogs</Breadcrumb.Item>
                <Breadcrumb.Item active>
                  {id ? "Edit Blog" : "Add New Blog"}
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <Toast
              bg="success"
              onClose={() => setShow(false)}
              show={show}
              delay={2000}
              autohide
            >
              <Toast.Header>
                <img
                  src="holder.js/20x20?text=%20"
                  className="rounded me-2"
                  alt=""
                />
                <strong className="me-auto text-success ">Success</strong>
              </Toast.Header>
              <Toast.Body className="text-white">
                Blog Updated Successfully...!
              </Toast.Body>
            </Toast>
            <div>
              <Link to="/cms/all-posts" className="btn btn-outline-white">
                Back to All Post
              </Link>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xl={9} lg={8} md={12} sm={12}>
          <Card>
            <Card.Header>
              <h4 className="mb-0">{id ? "Edit Blog" : "Add New Blog"}</h4>
            </Card.Header>
            <Card.Body>
              {/*  Form  */}
              <Form className="mt-1">
                <Row>
                  <Col md={9} sm={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Blog Status</Form.Label>
                      {/* <FormSelect */}
                      <Form.Select
                        aria-label="Default select example"
                        name="active_ind"
                        value={formData.active_ind}
                        onChange={handleChange}
                        required
                      >
                        {activeIndList.map(({ value, label }, index) => (
                          <option value={value} key={value}>
                            {label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    {/* 
										<Form.Group className="mb-3">
										{activeIndList.map(({ value, label }, index) => 
											<Form.Check
											inline
											label={label}
											name="active_ind"
											type='radio'
											id={"active_ind_" + value}
											onChange={handleChange}
											/>										
										)}
										</Form.Group>
										*/}
                  </Col>
                  <Col md={9} sm={12}>
                    {/* Title  */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="postTitle">Blog Header</Form.Label>
                      <Form.Control
                        name="content_header"
                        type="text"
                        value={formData.content_header || ""}
                        placeholder="Blog Title"
                        id="postTitle"
                        maxLength="255"
                        minLength="20"
                        required
                        onChange={handleChange}
                      />
                      <Form.Text className="text-muted">
                        Field must contain a unique value. Max 255 characters.
                      </Form.Text>
                    </Form.Group>
                    {/* Category */}
                    <Form.Group className="mb-3">
                      <Form.Label>Category</Form.Label>
                      {/* <FormSelect */}
                      <Form.Select
                        aria-label="Default select example"
                        name="category_id"
                        //options={categoryOptions}
                        value={formData.category_id}
                        onChange={handleChange}
                        required
                      >
                        {categoryOptions.map(({ value, label }, index) => (
                          <option value={value} key={value}>
                            {label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    {/* Author */}
                    <Form.Group className="mb-3">
                      <Form.Label>Author Name</Form.Label>
                      {/* <FormSelect */}
                      <Form.Select
                        aria-label="Default select example"
                        name="author_id"
                        //options={categoryOptions}
                        value={formData.author_id}
                        onChange={handleChange}
                        required
                      >
                        {authorOptions.map(({ value, label }, index) => (
                          <option value={value} key={value}>
                            {label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    {/* Author */}
                    {/*
										<Form.Group className="mb-3">
											<Form.Label>Author</Form.Label>
											<FormSelect 
											name="author_id"
											options={authorOptions} 
											defaultValue={formData.author_id} 
											onChange={handleChange}
											/>
											
										</Form.Group>
										*/}
                    {/* Excerpt */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="Excerpt">Preview Text</Form.Label>
                      <Form.Control
                        name="preview_text"
                        value={formData.preview_text || ""}
                        as="textarea"
                        placeholder="Preview Text"
                        id="Excerpt"
                        style={{ height: "100px" }}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                  {/** Content Images */}
                  <Col lg={12} md={12} sm={12}>
                    {/* Title  */}
                    <Row>
                      <Form.Group className="mb-3 col-6">
                        <Form.Label htmlFor="image_1000_540_scroller">
                          Blog Scroller and preview Image (1000 x 540)
                        </Form.Label>
                        {formData.image_1000_540_scroller ? (
                          <Fragment>
                            <Image
                              src={
                                s3 +
                                "blogImages/" +
                                formData.image_1000_540_scroller
                              }
                              thumbnail
                            />
                          </Fragment>
                        ) : (
                          <Row>
                            <div>Image not uploaded</div>
                          </Row>
                        )}
                        <Form.Control
                          name="image_1000_540_scroller"
                          type="file"
                          text={formData.image_1000_540_scroller || ""}
                          placeholder="Blog Scroller and preview Image"
                          id="image_1000_540_scroller"
                          maxLength="255"
                          minLength="20"
                          required
                          onChange={handleImageChange}
                        />
                        <Form.Text className="text-muted">
                          Blog Scroller image and preview image. This will also
                          be shown at the top of the blog after blog heading.
                        </Form.Text>
                      </Form.Group>
                      {/* Blog Scroller Image ALt text  */}
                      <Form.Group className="mb-3 col-6">
                        <Form.Label htmlFor="postTitle">
                          Blog Scroller Image (1000 x 540) Alt Text
                        </Form.Label>
                        <Form.Control
                          name="image_1000_540_scroller_alt"
                          type="text"
                          value={formData.image_1000_540_scroller_alt || ""}
                          placeholder="Blog Scroller Image Alt Text"
                          id="image_1000_540_scroller_alt"
                          maxLength="255"
                          minLength="20"
                          required
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Row>
                    {/* Blog Preview Image */}
                    <Row>
                      {/*
										<Form.Group className="mb-3 col-6">
											<Form.Label htmlFor="image_1000_540_blog_preview">Blog Preview Image (1000 x 540)</Form.Label>
											<Form.Control
												name="image_1000_540_blog_preview"
												type="text"
												value={formData.image_1000_540_blog_preview || ''}
												placeholder="Blog Preview Image"
												id="image_1000_540_blog_preview"
												maxLength="255"
												minLength="20"
												required
												onChange={handleChange}
											/>
											<Form.Text className="text-muted">
												Blog Preview image shown on the blog landing page.
											</Form.Text>
										</Form.Group>
										* */}
                      {/* Blog Preview Image ALt text  */}

                      {/*
										<Form.Group className="mb-3  col-6">
											<Form.Label htmlFor="image_1000_540_blog_preview_alt">Blog Preview Image (1000 x 540) Alt Text</Form.Label>
											<Form.Control
												name="image_1000_540_blog_preview_alt"
												type="text"
												value={formData.image_1000_540_blog_preview_alt || ''}
												placeholder="Blog Preview Image Alt Text"
												id="image_1000_540_blog_preview_alt"
												maxLength="255"
												minLength="20"
												required
												onChange={handleChange}
											/>
										</Form.Group>
									* */}
                    </Row>
                  </Col>
                  <Col lg={12} md={12} sm={12}>
                    {/*   Slug  */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="generated_url">
                        Generated URL (auto-generated)
                      </Form.Label>
                      <InputGroup>
                        <InputGroup.Text id="basic-addon3">
                          https://internshipgate.com/blog/
                        </InputGroup.Text>
                        <FormControl
                          onChange={handleChange}
                          name="generated_url"
                          id="generated_url"
                          aria-describedby="basic-addon3"
                          placeholder="designcourses"
                          value={formData.generated_url || ""}
                        />
                      </InputGroup>
                      <Form.Text className="text-muted">
                        {" "}
                        <small>
                          <Link
                            to={"/blog/" + blog.generated_url}
                            target="_blank"
                          >
                            Preview Blog Post
                          </Link>
                        </small>
                      </Form.Text>
                    </Form.Group>

                    {/* Editor */}
                    {/*console.log(formData.element_description)*/}

                    <Form.Group className="mb-3">
                      <ReactQuillEditor
                        name="element_description"
                        //id="element_description"
                        value={formData.element_description}
                        onChange={handleEditorChange}
                        required
                      />
                    </Form.Group>
                    {/**
										<Form.Group className="mb-3">
											<Form.Label htmlFor="element_description">Blog Description</Form.Label>
											<Form.Control
												name="element_description"
												value={formData.element_description || ''}
												as="textarea"
												placeholder="Blog Description"
												id="element_description"
												style={{ height: '400px' }}
												onChange={handleChange}
											/>
										</Form.Group>
										*/}
                  </Col>
                  
                  {/************** SEO Settings - start */}
                  <Col lg={12} md={12} sm={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Page Title</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Page Title"
                      id="seo_title"
                      name="seo_title"
                      value={formData.seo_title || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>          
                  <Form.Group className="mb-3">
                    <Form.Label>Meta Description</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Meta Description"
                      id="meta_description"
                      name="meta_description"
                      value={formData.meta_description || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>          
                  <Form.Group className="mb-3">
                    <Form.Label>Meta Keywords</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Meta Keywords"
                      id="meta_keywords"
                      name="meta_keywords"
                      value={formData.meta_keywords || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>            
                  </Col>         
                  {/************** SEO Settings - end */}
                  <Col lg={12} md={12} sm={12}>
                    {/* Publish Date */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="selectDate">
                        Last Publish Date: {blog.publish_date}
                      </Form.Label>
                    </Form.Group>
                    {/**
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="publish_date">
                        Publish Date
                      </Form.Label>
                      <FlatPickr
                        name="publish_date"
                        id="publish_date"
                        value={formData.publish_date}
                        onChange={handleChange}
                      />
                    </Form.Group>
                     */}
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="selectDate">
                        Created Date: {blog.created_at}
                      </Form.Label>
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label htmlFor="selectDate">
                        Modified Date: {blog.updated_at}
                      </Form.Label>
                    </Form.Group>
                  </Col>

                  <Col lg={12} md={12} sm={12}>
                    {/* button */}
                    <Form.Group className="mb-3">
                      <Button
                        onClick={handleSubmit}
                        variant="primary"
                        className="m-1"
                      >
                        Save
                      </Button>
                      {/* <Button variant="outline-white">Save to Draft</Button> */}
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        
        </Col>

        {/* Right hand side section */}
        <Col xl={3} lg={4} md={12} sm={12}>
          {/*  List group  */}
          <Card className="mt-4 mt-lg-0 mb-4">
            <Card.Header className="d-lg-flex">
              <h4 className="mb-0">Post Info</h4>
            </Card.Header>
            <Card.Body className="p-0">
              {/*  List group  */}
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <span className="text-body">Blog ID</span>
                  <h5>{blog.id}</h5>
                </ListGroup.Item>
                <ListGroup.Item>
                  <span className="text-body">Status</span>
                  <h5>
                    <DotBadge
                      bg={
                        blog.active_ind === 1
                          ? "warning"
                          : blog.active_ind === 2
                          ? "success"
                          : blog.active_ind === 0
                          ? "info"
                          : blog.active_ind === 3
                          ? "danger"
                          : ""
                      }
                    >
                      {blog.content_status}
                    </DotBadge>
                  </h5>
                </ListGroup.Item>
                <ListGroup.Item>
                  <span className="text-body">Created by</span>
                  <div className="d-flex mt-2">
                    <Image
                      src={Avatar1}
                      alt=""
                      className="avatar-sm rounded-circle"
                    />
                    <div className="ms-2">
                      <h5 className="mb-n1">{blog.author_name}</h5>
                      {/* <small>Admin</small> */}
                    </div>
                  </div>
                </ListGroup.Item>
                <ListGroup.Item>
                  <span className="text-body">Created at</span>
                  <h5>{blog.created_at}</h5>
                </ListGroup.Item>
                <ListGroup.Item>
                  <span className="text-body">Last update</span>
                  <h5>{blog.modified_at}</h5>
                </ListGroup.Item>
                <ListGroup.Item>
                  <span className="text-body">Publish Date</span>
                  <h5>{blog.modified_at}</h5>
                </ListGroup.Item>
                {/* 
								<ListGroup.Item className="bg-transparent">
									<span className="text-body">Last Published</span>
									<h5>Aug 31, 12:21 PM</h5>
								</ListGroup.Item>
								*/}
              </ListGroup>
            </Card.Body>
          </Card>

          <Card className="mt-4 mt-lg-0 mb-4">
            <Card.Header className="d-lg-flex">
              <h4 className="mb-0">Actions</h4>
            </Card.Header>
            <Card.Body className="p-0">
              {/*  List group  */}
              <ListGroup variant="flush">
                <ListGroup.Item className="d-flex justify-content-between align-items-center">
                  <span className="text-body">Unpublish</span>
                  <Link to="#" className="text-inherit">
                    <XCircle size="18px" />{" "}
                  </Link>
                </ListGroup.Item>

                <ListGroup.Item className="d-flex justify-content-between align-items-center">
                  <span className="text-body">Duplicate</span>
                  <Link to="#" className="text-inherit">
                    <Copy size="18px" />
                  </Link>
                </ListGroup.Item>

                <ListGroup.Item className="d-flex justify-content-between align-items-center bg-transparent">
                  <span className="text-body">Delete</span>
                  <Link to="#">
                    <Trash size="18px" className="text-danger" />
                  </Link>
                </ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
       
          {/* 
					<Card className="mt-4 mt-lg-0 mb-4">
						<Card.Header className="d-lg-flex">
							<h4 className="mb-0">Revision History</h4>
						</Card.Header>
						<Card.Body className="p-0">
							<ListGroup variant="flush">
								<ListGroup.Item className="d-flex justify-content-between align-items-center bg-transparent">
									<div>
										<h5 className="mb-0">Aug 31, 12:21 PM</h5>
										<span className="text-body">Geeks Coures</span>
									</div>
									<div>
										<Badge bg="success">Published</Badge>
									</div>
								</ListGroup.Item>
							</ListGroup>
						</Card.Body>
					</Card>
					*/}
        </Col>
      </Row>
    </Fragment>
  );
};

export default AddNewPost;
